export default __webpack_public_path__ + "static/media/sellersparr.0237733d.jpg";